export function isAxeptioEnabled(): boolean {
  if (import.meta.env.DEV) {
    return false;
  }

  const clientId =
    (import.meta.env.VITE_AXEPTIO_CLIENT_ID as string | undefined)
      ?.trim() ?? '';
  const cookiesVersion =
    (import.meta.env.VITE_AXEPTIO_COOKIES_VERSION as string | undefined)
      ?.trim() ?? '';

  return clientId.length > 0 && cookiesVersion.length > 0;
}
